import { render, staticRenderFns } from "./SendCustomNotification.vue?vue&type=template&id=1f8f36fc&scoped=true"
import script from "./SendCustomNotification.vue?vue&type=script&lang=js"
export * from "./SendCustomNotification.vue?vue&type=script&lang=js"
import style0 from "./SendCustomNotification.vue?vue&type=style&index=0&id=1f8f36fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f36fc",
  null
  
)

export default component.exports